import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, Input, Cascader, Form, Select, Row, Col,
} from 'antd';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
import { BEDCART_CALL_FORMATS } from '@constants/UHESettings';

const { Option } = Select;

const { TextArea } = Input;

/**
 * Renders Device Type Card in ManageNonUheBedCart file
 * @param {Object} bedCart bedCart
 * @param {boolean} loading loading
 * @param {function} onChangeDeviceType onChangeDeviceType
 * @param {Array} deviceTypes deviceTypes
 * @param {function} onChangeCallFormat onChangeCallFormat
 * @param {Object} intl Translations
 * @returns {JSX} React Element
 */
function DeviceTypeCard({
  bedCart,
  loading,
  onChangeDeviceType,
  deviceTypes,
  onChangeCallFormat,
  onChangeAddress,
  intl,
}) {
  const callFormats = BEDCART_CALL_FORMATS.map((callFormat, index) => (
    <Option key={index} value={callFormat}>
      {callFormat}
    </Option>
  ));

  const [bedCartType, setBedCartType] = useState();

  useEffect(() => {
    setBedCartType(bedCart.dial_out_type);
  }, [bedCart]);

  return (
    <Card
      loading={loading}
      className="gx-card"
      title={<IntlMessages id="configuration.bedsCarts.deviceDetails" />}
    >
      <Row>
        <Col span={23}>
          <Form.Item
            label={<IntlMessages id="configuration.bedsCarts.deviceType" />}
            name="endpoint_type"
          >
            <Cascader
              expandTrigger="hover"
              size="large"
              key="deviceTypes"
              options={deviceTypes || []}
              fieldNames={{ label: 'value', value: 'value' }}
              value={[bedCart.endpoint_type]}
              onChange={onChangeDeviceType}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={23}>
          <Form.Item
            label={<IntlMessages id="configuration.bedsCarts.callFormat" />}
          >
            <Select
              value={[bedCartType]}
              onChange={(ev) => onChangeCallFormat(ev, 'dial_out_type')}
            >
              {callFormats}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={23}>
          <Form.Item
            label={<IntlMessages id="configuration.bedsCarts.sipAddress" />}
            rules={[
              {
                required: true,
                type: 'email',
                message: intl.formatMessage({
                  id: 'common.error_email',
                }),
              },
            ]}
            name="alias"
          >
            <Input
              autoComplete={Math.random()}
              name="alias"
              value={bedCart.alias}
              onChange={(e) => onChangeAddress(e, 'alias')}
              longdecs={intl.formatMessage({
                id: 'configuration.bedsCarts.descriptions.address',
              })}
              placeholder={intl.formatMessage({
                id: 'configuration.bedsCarts.addrPlaceholder',
              })}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={23}>
          <Form.Item
            label={<IntlMessages id="configuration.bedsCarts.acknowledged.notes" />}
            name="notes"
          >
            <TextArea
              autoSize={{ minRows: 4, maxRows: 10 }}
              autoComplete={Math.random()}
              name="notes"
              value={bedCart.notes}
              onChange={(e) => onChangeAddress(e, 'notes')}
              placeholder={intl.formatMessage({
                id: 'configuration.bedsCarts.acknowledged.notes',
              })}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}

DeviceTypeCard.propTypes = {
  bedCart: PropTypes.object,
  intl: PropTypes.object,
  loading: PropTypes.bool,
  deviceTypes: PropTypes.array,
  onChangeDeviceType: PropTypes.func,
  onChangeCallFormat: PropTypes.func,
  onChangeAddress: PropTypes.func,
};

export default injectIntl(DeviceTypeCard);
